module.exports = __webpack_public_path__ + "assets/img/mecha-a5138c5d.png";